import { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as chiefdomService from '../../services/chiefdomAPI';
import { fetchChiefdomListFailure, fetchChiefdomListSuccess } from './actions';
import { FETCH_CHIEFDOM_LIST_REQUEST } from './actionTypes';
import { IFetchChiefdomListRequest } from './types';

export function* fetchChiefdomListSagaRequest({
  districtId,
  successCb,
  failureCb
}: IFetchChiefdomListRequest): SagaIterator {
  try {
    const { data: { entity: list, totalCount: total } } = yield call(
      chiefdomService.fetchChiefdomList as any,
      districtId
    );
    const payload = { chiefdomList: list, total };
    successCb?.(payload);
    yield put(fetchChiefdomListSuccess(payload));
  } catch (e) {
    if (e instanceof Error) {
      failureCb?.(e);
      yield put(fetchChiefdomListFailure(e));
    }
  }
}

function* chiefdomSaga() {
  yield all([takeLatest(FETCH_CHIEFDOM_LIST_REQUEST, fetchChiefdomListSagaRequest)]);
}

export default chiefdomSaga;
